import React from 'react';
import { Box, Dialog, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import { Map, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';
import { useLocale } from 'hooks';

import { CloseIcon } from '../icons/closeIcon/CloseIcon';
import markerIcon from 'assets/images/marker.svg';

import { useStyles } from './LocationModal.styles';
import { LocationModalProps } from './LocationModal.types';

const marker = new L.Icon({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon,
  iconSize: [33, 39],
  iconAnchor: [16, 39],
  popupAnchor: [1, -37],
});

export const LocationModal = ({ isOpened, handleClose, latitude, longitude }: LocationModalProps) => {
  const classes = useStyles();
  const { formatMessage } = useLocale();

  const state = {
    lat: latitude,
    lng: longitude,
    zoom: 20,
  };

  const position = { lat: state.lat, lng: state.lng };

  return (
    <Dialog onClose={handleClose} open={isOpened} PaperProps={{ className: classes.container }} maxWidth="lg" fullWidth>
      <DialogTitle className={classes.titleContainer} disableTypography>
        {formatMessage({ id: 'location_modal.title' })}
        <IconButton onClick={handleClose} size="small">
          <CloseIcon className={classes.closeIcon} />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers className={classes.content}>
        <Box className={classes.mapContainer} data-testid="location-map">
          <Map center={position} zoom={state.zoom}>
            <TileLayer
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={position} icon={marker} />
          </Map>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
